export default {
	PACKAGE_NAMESPACE_DEPOSITS: 'deposits',
	PACKAGE_NAMESPACE_MESSAGING: 'messaging',
	PACKAGE_NAMESPACE_ADVANCEDDOCUMENTS: 'advanced_documents',
	PACKAGE_NAMESPACE_ADVANCED_PRICING: 'adv.pricing1',
	PACKAGE_NAMESPACE_ENTERPRISE: 'enterprise1',
	PACKAGE_NAMESPACE_EXTERNAL_ANALYTICS: 'extanalytics',
	PACKAGE_NAMESPACE_PROMOCODES: 'PromoCodes',

	SESSION_STRIPE_PUB_KEY: 'stripe.publishableKey',
	SESSION_HASHCODE: 'X-API-KEY',
	GOOGLE_API_KEY: 'googleAPIKey',
	SEARCH_PARAMS: 'SEARCH_PARAMS',
	ORDER_PARAMS: 'ORDER_PARAMS',
	PRODUCTS_IN_CART: 'PRODUCTS_IN_CART',
	SCREEN_NAMES: ['Activation', 'Registration', 'Customer_Login', 'Search', 'Product', 'Payment', 'Header'],
	PRODUCT_TYPE: 'PRODUCT_TYPE',
	SEARCH_DEFAULT: 'default',
	SEARCH_BY_LOCATION: 'by_location',
	SEARCH_NEWEST_FIRST: 'newest_first',
	SEARCH_OLDEST_FIRST: 'oldest_first',
	SAVED_PAGE: 'SAVED_PAGE',
};
